import { Phone, CheckCircle2, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { SiteLayout, PageHero, SectionTag, WhatsAppIcon, waLink, PHONE_PRIMARY, PHONE_PRIMARY_TEL, useSEO } from "./shared";

const SUPPORT_ITEMS = [
  "Initial site assessment",
  "Fire protection system planning",
  "System installation",
  "Rectification of existing-system deficiencies",
  "Testing & commissioning",
  "Fire protection drawings & documentation support",
  "Preparation assistance for Fire Safety Certificate / NOC applications",
  "Ongoing maintenance",
];

export default function FireNOC() {
  useSEO(
    "Fire Safety & NOC Support in Tripura | SecureFlame Fire Systems",
    "SecureFlame provides technical and documentation support for fire safety compliance and Fire NOC preparation across Tripura — site assessment, installation, testing and commissioning."
  );
  return (
    <SiteLayout>
      <PageHero eyebrow="Compliance Support" title="Fire Safety & NOC Support in Tripura" subtitle="SecureFlame helps property owners and businesses get compliance-ready with technical assessment, system installation and documentation support." />

      <section className="max-w-7xl mx-auto px-6 py-16 md:py-20 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7">
          <SectionTag>How We Support You</SectionTag>
          <h2 className="font-heading font-bold text-3xl tracking-tight text-secondary mb-6">From assessment to compliance-readiness.</h2>
          <ul className="space-y-3.5">
            {SUPPORT_ITEMS.map((t) => (
              <li key={t} className="flex items-start gap-3 text-sm text-secondary"><CheckCircle2 size={18} className="text-primary shrink-0 mt-0.5" /> {t}</li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-5">
          <div className="bg-secondary text-white rounded-sm p-7 blueprint-bg" data-testid="noc-disclaimer">
            <AlertTriangle className="text-gold mb-3" size={26} />
            <p className="text-sm leading-relaxed">Fire Safety Certificates and NOCs are issued only by the appropriate statutory / government authority. SecureFlame provides technical and documentation support and does not issue, approve or guarantee statutory approvals.</p>
          </div>
        </div>
      </section>

      <section className="relative blueprint-bg text-white">
        <div className="relative max-w-4xl mx-auto px-6 py-16 md:py-20 text-center">
          <SectionTag light>Get Started</SectionTag>
          <h2 className="font-heading font-black text-3xl sm:text-4xl tracking-tight">Request a Fire Safety Assessment</h2>
          <p className="mt-4 text-slate-300 max-w-xl mx-auto">Tell us about your building and requirements — our team will get in touch to plan the next steps.</p>
          <Link to="/contact?type=quote&service=fire-noc-support"><Button size="lg" className="mt-8 rounded-sm bg-primary hover:bg-primary/90 font-semibold" data-testid="noc-assessment-btn">REQUEST FIRE SAFETY ASSESSMENT</Button></Link>
          <div className="mt-6 flex flex-wrap gap-3.5 justify-center">
            <a href={`tel:${PHONE_PRIMARY_TEL}`}><Button size="lg" variant="outline" className="rounded-sm border-white/25 text-white bg-transparent hover:bg-white/10 gap-2 font-semibold" data-testid="noc-call-btn"><Phone size={17} /> CALL NOW</Button></a>
            <a href={waLink()} target="_blank" rel="noreferrer"><Button size="lg" variant="outline" className="rounded-sm border-white/25 text-white bg-transparent hover:bg-white/10 gap-2 font-semibold" data-testid="noc-whatsapp-btn"><WhatsAppIcon size={17} /> WHATSAPP</Button></a>
            <Link to="/contact?type=site_visit"><Button size="lg" variant="outline" className="rounded-sm border-white/25 text-white bg-transparent hover:bg-white/10 font-semibold" data-testid="noc-sitevisit-btn">BOOK SITE VISIT</Button></Link>
          </div>
          <p className="mt-6 text-xs text-slate-400">{PHONE_PRIMARY}</p>
        </div>
      </section>
    </SiteLayout>
  );
}
